export const progressBarConstants = {
  PROGRESS_BAR_GET_LIST: 'PROGRESS_BAR_GET_LIST',
  PROGRESS_BAR_NEXT_STEP: 'PROGRESS_BAR_NEXT_STEP',
  PROGRESS_BAR_REMOVE_STEP: 'PROGRESS_BAR_REMOVE_STEP',
}